import { CommentDto, CreateCommentDto, CreateLeadCommentsBulkDto, CreateLeadCommentsBulkResultDto } from '@sr/dto';
import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from 'shared/api/rtk-query';

export const commentsApi = createApi({
  reducerPath: 'commentsApi',
  baseQuery: createBaseQuery(),
  endpoints: (builder) => ({
    fetchLeadComment: builder.query<CommentDto[], number>({
      query: (leadId) => `/lead/${leadId}/comments`,
      providesTags: (result, error, leadId) => [{ type: 'lead-comments', id: leadId }],
    }),
    postLeadComment: builder.mutation<CommentDto, { leadId: number; dto: CreateCommentDto }>({
      query: ({ leadId, dto }) => ({
        url: `/lead/${leadId}/comments`,
        method: 'POST',
        body: dto,
      }),
      invalidatesTags: (result, error, { leadId }) => [{ type: 'lead-comments', id: leadId }],
    }),
    postLeadCommentsBulk: builder.mutation<CreateLeadCommentsBulkResultDto, CreateLeadCommentsBulkDto>({
      query: (dto) => ({
        url: '/lead/comments/bulk',
        method: 'POST',
        body: dto,
      }),
      invalidatesTags: (result, error, { items }) => (items ?? []).map((item) => ({ type: 'lead-comments', id: item.leadId })),
    }),
    fetchPurchaseComment: builder.query<CommentDto[], number>({
      query: (purchaseId) => `/purchases/${purchaseId}/comments`,
      providesTags: (result, error, purchase) => [{ type: 'purchase-comments', id: purchase }],
    }),
    postPurchaseComment: builder.mutation<CommentDto, { purchaseId: number; dto: CreateCommentDto }>({
      query: ({ purchaseId, dto }) => ({
        url: `/purchases/${purchaseId}/comments`,
        method: 'POST',
        body: dto,
      }),
      invalidatesTags: (result, error, { purchaseId }) => [{ type: 'purchase-comments', id: purchaseId }],
    }),
  }),
  tagTypes: ['lead-comments', 'purchase-comments'],
});
